import { render, staticRenderFns } from "./antecedente.vue?vue&type=template&id=0e175907"
import script from "./antecedente.vue?vue&type=script&lang=js"
export * from "./antecedente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports